export { default as QuickBookingArticle } from './QuickBookingArticle'
